import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

import React from 'react';

export const InputTextField = ({ control, name, ...props }: any) => {
    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <TextField
                    {...field}
                    {...props}
                />
            )}
        />
    );
}
